module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "mt-7",
    attrs: {
      "align": "center"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  }, [_c('v-container', {
    staticClass: "mt-7",
    attrs: {
      "fluid": "",
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "col-height-auto",
    attrs: {
      "xs12": "",
      "md12": "",
      "lg12": "",
      "sm12": ""
    }
  }, [_c('div', {
    staticClass: "app-card"
  }, [_c('v-data-table', {
    staticClass: "elevation-3",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.transactionList,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_c('a', {
          on: {
            "click": function($event) {
              return _vm.goTransactionData(props.item)
            }
          }
        }, [_vm._v("\n                        " + _vm._s((props.item.hash.length) > 18 ? (props.item.hash).substring(0, 18) + '...' : (props.item.hash)) + "\n                      ")])]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_c('span', [_vm._v("\n                        " + _vm._s(_vm.timeStampToTime(props.item.timeStamp)) + "\n                      ")])]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_c('a', [_vm._v("\n                        " + _vm._s((props.item.from.length) > 18 ? (props.item.from).substring(0, 18) + '...' : (props.item.from)) + "\n                      ")])]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_c('a', [_vm._v("\n                        " + _vm._s(_vm.subToHash(props.item.input)) + "\n                      ")])]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_c('span', [_vm._v("\n                        " + _vm._s(_vm.getQuantity(props.item.input)) + "\n                      ")])])]
      }
    }])
  })], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-3 mb-5 text-xs-center"
  }, [_c('Page', {
    attrs: {
      "total": _vm.totalTransactionNumber,
      "pageSize": _vm.pageSize,
      "simple": ""
    },
    on: {
      "on-change": _vm.getTransactionByPage
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-754bbf36"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/token/Transaction.vue
// module id = 458
// module chunks = 0